import React, { useState, useEffect, useContext } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import { AdminRoutes } from '../../AppRoutes';
import { NavbarBrand } from 'reactstrap';
import logo from '../../content/img/logo.png';
import { MdClose, MdOutlineSegment } from "react-icons/md";
import { DataContext } from "../../App";

const Sidebar = () => {
    const [isMobileTablet, setIsMobileTablet] = useState(window.matchMedia("(max-width: 991px)").matches);
    const context = useContext(DataContext);

    useEffect(() => {
        const handleResize = () => setIsMobileTablet(window.matchMedia("(max-width: 991px)").matches);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [isOpen, setIsOpen] = useState(isMobileTablet ? false : true);

    // Filter out only the required routes for the sidebar
    const filteredRoutes = AdminRoutes.filter(route => route.isInSidebar);

    return (
        <>
            {(isOpen || !isMobileTablet) && (
                <div className="navbar-vertical-content sidebar-open">
                    <NavbarBrand tag={Link} to="/admin">
                        <img src={logo} alt="Feeling Italy logo" height="50" className="d-inline-block align-top mb-5 cursor-pointer"/>
                    </NavbarBrand>
                    <ul className="navbar-nav flex-column mt-5 position-relative" id="navbarVerticalNav">
                        {filteredRoutes.map((item, index) => (
                            <NavItem key={index}>
                                <div onClick={() => setIsOpen(false)}>
                                    <NavLink 
                                        tag={Link} 
                                        className="text-white dropdown-indicator" 
                                        to={context.loading ? "#" : item.path}
                                    >
                                            <span className={`link-header-admin my-0 text-black text-capitalize ${(window.location.pathname.includes(item.path)|| (item.name === "Pages" && window.location.pathname === "/admin")) ? "fw-semibold" : ""}`}>{item.name}</span>
                                    </NavLink>
                                </div>
                            </NavItem>
                        ))}
                    </ul>
                </div>
            )}

            {isMobileTablet && (
                <div className="sidebar-open-close-btn-container">
                    <button onClick={() => setIsOpen(!isOpen)} className="sidebar-open-close-btn">
                        {isOpen ? <MdClose className="text-white btn-icon"/> : <MdOutlineSegment className="text-white btn-icon"/>}
                    </button>
                </div>
            )}
        </>
    );
};

export default Sidebar;
